import { makeStyles } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";

import logo from "../shared-resources/images/NextQ.png";
import { GreenLogoSmall } from "../shared-resources/SVGIcons";
import KirklandEllisLogo from "../images/KirklandLogo.png";

const useStyles = makeStyles((theme) => ({
  componentStyles: {
    marginTop: "150px",
    textAlign: "center",
    fontSize: "12px",
    padding: "12px",
  },
  logoIcon: {
    height: "8px",
    width: "120px",
  },
}));

export default function Footer() {
  const classes = useStyles();

  const isMenuOpened = useSelector((state) => state.commonReducer.isMenuOpened);
  return (
    <footer id="footer">
      <div id="footerData">
        <div
          className={isMenuOpened ? "footerDataInner" : "footerDataInnerClosed"}
        >
          <span className="poweredByText"> Powered by </span>

          <span className="footorLogo">
            <img
              src={KirklandEllisLogo}
              alt="Logo"
              className={classes.logoIcon}
            />
          </span>
        </div>
      </div>
    </footer>
  );
}
